import React from 'react'
import styled from 'styled-components'
import brandStyles from './brand.styles'

interface ApBrandProps {
  ap_brand: string
  ap_position: 'app_bar' | 'app_content_area'
}

const apAtomName = {ap_atom_name: 'apBrandAtom'}
const StyledWrapper = styled(props => <div {...props} />)`
  ${brandStyles};
`

const BrandAtom: React.FC<ApBrandProps> = function BrandAtom({
  ap_brand,
  ...restProps
}) {
  return (
    <StyledWrapper {...apAtomName} {...restProps}>
      <img alt="Logo" src={ap_brand} />
    </StyledWrapper>
  )
}

export default BrandAtom
